import React from 'react';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { TranslationPushCommand } from '../components/TranslationPushCommand/index.js';
import type { ProjectModel } from '../model.js';
import { log } from './logger.js';
import { executeCommand } from './execute-command.js';

export async function nonInteractiveTranslationPush(
  services: AstroCommandServices,
  model: ProjectModel
) {
  await executeCommand<void>(services, model, (resolve) => (
    <TranslationPushCommand onComplete={resolve} skipConfirmation />
  ));

  log(JSON.stringify({ success: true }, null, 2));
}
